import { MutationTree } from "vuex";
import { StudentTeachingState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const mutations: MutationTree<StudentTeachingState> = {
  //setCurrentIndependentItemId
  [defineVuexName(MODULES.STUDENT_TEACHING.COMMITS.SET_CURRENT_INDEPENDENT_ITEM_ID)](state: StudentTeachingState, payload: string) {
    state.currentIndependentItemId = payload;
  },
};

export default mutations;
